/** Classe CSS de cor para uma variação ("-1.2%", "0.5", ...). */
export function getClassColor(value: string) {
  if (!value || value.trim() === '') {
    return '';
  }

  const num = parseFloat(value.replace('%', '').trim());

  if (isNaN(num)) {
    return '';
  }

  if (num < 0) {
    return 'change-negative';
  }
  if (num > 0) {
    return 'change-positive';
  }

  return 'change-neutral';
}
